import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { useT } from '@/i18n/I18nProvider'

interface Fix {
  id: string; ruleId: string; status: string; mode: string; severity: string; confidence: number | null
  createdAt: string; appliedAt: string | null
}

export function AdminFixesPage() {
  const t = useT()
  const [statusFilter, setStatusFilter] = useState('')
  const fixes = useQuery({
    queryKey: ['admin-fixes', statusFilter],
    queryFn: () => {
      const params = new URLSearchParams()
      if (statusFilter) params.set('status', statusFilter)
      return apiClient.get<{ data: Fix[] }>(`/admin/fixes?${params}`)
    },
  })

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-4">{t('admin.fixes.title')}</h1>
      <div className="mb-4">
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className="px-2 py-1 text-sm border rounded bg-transparent"
          style={{ borderColor: 'var(--color-border)' }}
        >
          <option value="">{t('admin.fixes.allstatus')}</option>
          <option value="pending">pending</option>
          <option value="applied">applied</option>
          <option value="pr-opened">pr-opened</option>
          <option value="reported">reported</option>
          <option value="verified">verified</option>
          <option value="failed">failed</option>
          <option value="reverted">reverted</option>
        </select>
      </div>
      {fixes.isLoading && <p>{t('common.loading')}</p>}
      {fixes.data && (
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="text-left opacity-70">
              <th className="py-2 pr-4">{t('admin.fixes.column.rule')}</th>
              <th className="py-2 pr-4">{t('admin.fixes.column.mode')}</th>
              <th className="py-2 pr-4">{t('admin.fixes.column.severity')}</th>
              <th className="py-2 pr-4">{t('admin.fixes.column.status')}</th>
              <th className="py-2 pr-4">{t('admin.fixes.column.confidence')}</th>
              <th className="py-2 pr-4">{t('admin.fixes.column.created')}</th>
            </tr>
          </thead>
          <tbody>
            {fixes.data.data.map((f) => (
              <tr key={f.id} className="border-t" style={{ borderColor: 'var(--color-border)' }}>
                <td className="py-2 pr-4 text-xs font-mono">{f.ruleId}</td>
                <td className="py-2 pr-4">{f.mode}</td>
                <td className="py-2 pr-4">{f.severity}</td>
                <td className="py-2 pr-4">{f.status}</td>
                <td className="py-2 pr-4">{f.confidence !== null ? `${(f.confidence * 100).toFixed(0)}%` : '—'}</td>
                <td className="py-2 pr-4">{new Date(f.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
